import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  createProjectModelFromProject(
    request: Boundaries["createProjectModelFromProject"]["request"],
  ): void;
}

function useCreateProjectModelFromProject(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isCreateProjectModelFromProjectRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isCreateProjectModelFromProjectRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isCreateProjectModelFromProjectRequestFailure,
    ),
    createProjectModelFromProject: core.createProjectModelFromProject,
  };
}

export { useCreateProjectModelFromProject };
